import Qs from 'qs'

export default {
  // 默认请求的接口
  url: '/',
  // 服务器地址
  baseURL: '',
  // 默认请求方法
  method: 'get',
  // 在发送请求之前对请求数据做处理
  transformRequest: [
    function (data) {
      return typeof (data) == "object" ? Qs.stringify(data) : data;
    }
  ],
  // 提前处理返回的数据=
  transformResponse: [
    function (data) {
      return data
    }
  ],
  // 请求头信息
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  // 默认parameter参数
  params: {},
  // 序列化param
  paramsSerializer: function (params) {
    return Qs.stringify(params)
  },
  // 默认post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
  data: {
  },
  // 设置超时时间
  timeout: 60 * 1000,
  // 是否跨站点访问控制请求
  withCredentials: true, // default
  // 返回数据类型
  responseType: 'json', // default
  // 将upload事件注释掉，防止跨域状态下发起option请求
  // onUploadProgress: function(progressEvent) {
  //   // Do whatever you want with the native progress event
  // },
  // onDownloadProgress: function(progressEvent) {
  //   // Do whatever you want with the native progress event
  // },
  maxContentLength: 2000,
  validateStatus: function (status) {
    return status >= 200 && status < 300 // default
  },
  // default
  maxRedirects: 5,
}
